const state = {
  team: null,
  employee: null,
  employeeAvatars: {}
};
const getters = {
  managerSelTeam: state => state.team,
  transferredEmployee: state => state.employee,
  getEmployeeAvatars: state => state.employeeAvatars
};
const mutations = {
  selectManagerTeam(state, id) {
    state.team = id
  },
  transferTeams(state, [teamId, employeeId]) {
    state.team = teamId
    state.employee = employeeId
  },
  setEmployeeAvatars(state, [userId, obj]) {
    state.employeeAvatars[userId] = obj
  },
  setAllEmployeeAvatars(state, obj) {
    state.employeeAvatars = obj
  },
};
  
export default {
  state,
  getters,
  mutations
};